/**
 * @format
 *
 */

import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Master from '../../Layouts/Master';
import { EventContext } from '../../../Contexts/EventContext';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import Pagination from '../../../Shared/Components/Pagination';
import moment from 'jalali-moment';
import { baseApiUrl, competitionLevelCase, matchGenderLabel } from '../../../Shared/utils/helper';
import Loading from '../../../Shared/Components/Loading';
import Datepicker from '../../../Shared/Components/Datepicker';
import { useNavigate } from 'react-router';

const Match = () => {
	const navigate = useNavigate();
	const eventContext = useContext(EventContext);
	const { search } = useLocation();
	const [loading, setLoading] = useState(false);
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [status, setStatus] = useState('');

	useEffect(() => {
		getMatch();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search]);
	const getMatch = async () => {
		setLoading(true);
		await useApi.get(
			'/panel/status',
			{},
			(res) => {
				eventContext.statuses = res.data.data;
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			`/panel/match/${search}`,
			{},
			(res) => {
				eventContext.matches = res.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};
	const searchMatch = () => {
		let start = fromDate.length > 0 ? '&start=' + fromDate : '';
		let end = toDate.length > 0 ? '&end=' + toDate : '';
		let statusCode = status.length > 0 ? '&status=' + status : '';

		let query = '';
		query += query.length > 0 ? start : start.replace('&', '');
		query += query.length > 0 ? end : end.replace('&', '');
		query += query.length > 0 ? statusCode : statusCode.replace('&', '');

		return navigate(`/panel/reports/match-lists?${query}`);
	};

	const exportMatchPayments = async (matchId) => {
		try {
			await useApi.downloadFile(
				`${baseApiUrl()}/panel/report/match/excel/export/${matchId}`,
			);
		} catch (err) {
			error('هنگام دریافت خروجی اکسل خطایی رخ داده است');
		}
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						لیست مسابقه
					</h1>
				</div>
				<Link
					to='/panel/matches/create'
					className='d-flex flex-row btn btn-outline-info '>
					<i className='fad fa-plus f-16 mx-2'></i>
					<span className='f-13'>ایجاد مسابقه</span>
				</Link>
			</div>
			<div className='d-flex flex-row w-100 my-1'>
				<div className='form-group d-flex flex-column mx-2'>
					<label>شروع برگزاری</label>
					<Datepicker
						handleChange={(name, value) => setFromDate(value)}
						name='start'
						value={fromDate}
					/>
				</div>
				<div className='form-group d-flex flex-column mx-2'>
					<label>پایان برگزاری</label>
					<Datepicker
						handleChange={(name, value) => setToDate(value)}
						name='end'
						value={toDate}
					/>
				</div>
				<div className='form-group d-flex flex-column mx-2'>
					<label>وضعیت</label>
					<select
						className='form-control'
						onChange={(e) => setStatus(e.target.value)}>
						<option disabled selected={true}>
							وضعیت...
						</option>
						{eventContext.statuses?.map((item) => (
							<option value={item.id}>{item.name_fa}</option>
						))}
					</select>
				</div>

				<div className='form-group mx-2 mt-1'>
					<button
						onClick={searchMatch}
						className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'>
						جستجو
					</button>
				</div>
			</div>
			<div className='w-100 overflow-auto'>
				{eventContext.matches?.data?.length > 0 ? (
					<table className='table table-hover'>
						<thead>
							<tr>
								<th>#</th>
								<th>عنوان</th>
								<th>سبک مسابقه</th>
								<th>شروع برگزاری</th>
								<th>پایان برگزاری</th>
								<th>سطح برگزاری</th>
								<th>جنسیت</th>
								<th>استان محل برگزاری</th>
								<th>شهر محل برگزاری</th>
								<th>وضعیت</th>
								<th>عملیات</th>
							</tr>
						</thead>
						<tbody>
							{eventContext.matches?.data?.map((item) => (
								<tr key={item.id}>
									<th>{item.id}</th>
									<td>{item.title}</td>
									<td>{item.match_style?.title}</td>
									<td>
										{moment(item.start ?? '1990-01-01', 'YYYY-MM-DD')
											.locale('fa')
											.format('YYYY/MM/DD')}
									</td>
									<td>
										{moment(item.end ?? '1990-01-01', 'YYYY-MM-DD')
											.locale('fa')
											.format('YYYY/MM/DD')}
									</td>
									<td>
										{competitionLevelCase(item?.match_style?.competition_level)}
									</td>
									<td>{matchGenderLabel(item?.gender)}</td>
									<td>{item?.province?.name}</td>
									<td>{item?.city?.name}</td>
									<td>
										<span
											className={`badge badge-${
												item.status?.id === 1
													? 'warning'
													: item.status?.id === 2
													? 'primary'
													: item.status?.id === 3
													? 'danger'
													: item.status?.id === 4
													? 'success'
													: ''
											} badge-pill p-2`}>
											{item.status?.id === 1
												? 'در حال انتظار'
												: item.status?.id === 2
												? 'تایید شده'
												: item.status?.id === 3
												? 'لغو شده'
												: item.status?.id === 4
												? 'برگزار شده'
												: ''}
										</span>
									</td>
									<td>
										<div className='d-flex flex-row'>
											<button
												type='button'
												onClick={() => exportMatchPayments(item.id)}
												className='btn btn-link mx-2 p-0 f-13'>
												پرداخت ها
											</button>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : null}
			</div>
			<div className='w-100 mt-4 d-flex'>
				<Pagination
					totalPage={eventContext.matches?.meta?.pagination?.total_pages}
					basePath='/panel/matches/lists'
				/>
			</div>
		</Master>
	);
};

export default Match;
